import { TextField } from '@mui/material';
import { AddInstallerForm } from 'components/Drawer/types';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  register: UseFormRegister<AddInstallerForm>;
  nameInputValue: string;
  handleNameInputOnChange: (value: string) => void;
  nameInputValidation: string | undefined;
  emailInputValue: string;
  handleEmailInputValueChange: (value: string) => void;
  emailInputValidation: string | undefined;
  showValidation: boolean;
}
const AddInstaller: React.FC<React.PropsWithChildren<Props>> = ({
  register,
  nameInputValue,
  handleNameInputOnChange,
  nameInputValidation,
  emailInputValue,
  handleEmailInputValueChange,
  emailInputValidation,
  showValidation
}) => {
  const { translation } = useTranslation();

  return (
    <ComponentWrapper flexDirection="column" gap="1.5rem" margin="0.5rem 0 0 0">
      <TextField
        {...register('name')}
        onChange={(event) => handleNameInputOnChange(event.target.value)}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        size="medium"
        label={translation.name}
        value={nameInputValue}
        id="drawer-input-name"
        error={showValidation && nameInputValidation !== undefined}
        helperText={showValidation ? nameInputValidation : undefined}
      />
      <TextField
        {...register('email')}
        onChange={(event) => handleEmailInputValueChange(event.target.value)}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        size="medium"
        label={translation.e_mail}
        value={emailInputValue}
        id="drawer-input-email"
        error={showValidation && emailInputValidation !== undefined}
        helperText={showValidation ? emailInputValidation : undefined}
      />
    </ComponentWrapper>
  );
};

export default AddInstaller;
